import React, { useEffect, useRef, useState } from 'react';
import api from '../api';
import { mensajeErrorApi } from '../apiErrors';
import { cargarPayphoneScript } from '../payphoneLoader';

/**
 * Pago con tarjeta de una liquidación, con la Cajita de Pagos de Payphone embebida.
 * Los montos (saldo, comisión de Payphone y total) los fija el SERVIDOR al iniciar el pago:
 * el navegador solo los muestra y se los pasa a la Cajita. Al aprobar, Payphone redirige a
 * responseUrl con ?id=&clientTransactionId=; la confirmación real (server-side, dentro de
 * 5 min) la hace ClientePanel al detectar esos parámetros, igual que Compra Asistida.
 */
export default function PagoPayphoneLiquidacion({ liquidacion }) {
  const contenedorId = `payphone-box-liq-${liquidacion.id}`;
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [montos, setMontos] = useState(null);
  const montado = useRef(false);
  const huesped = useRef(null);

  useEffect(() => {
    if (montado.current) return;
    montado.current = true;
    let cancelado = false;
    const contenedor = huesped.current;

    api.post(`/liquidaciones/${liquidacion.id}/iniciar-pago-tarjeta/`)
      .then(async (res) => {
        const d = res.data;
        setMontos(d);
        await cargarPayphoneScript();
        if (cancelado) return;

        const config = {
          token: d.payphone_token,
          clientTransactionId: d.client_transaction_id,
          amount: d.amount_centavos,
          amountWithoutTax: d.amount_centavos,
          amountWithTax: 0,
          tax: 0,
          service: 0,
          tip: 0,
          currency: 'USD',
          reference: d.referencia,
          // SIN query string propio: Payphone le pega su "?id=&clientTransactionId=" sin revisar si ya
          // había un "?" (ver PagoPayphoneCompraAsistida.js). El id de la liquidación viaja dentro
          // del clientTransactionId (`liq-<id>-<timestamp>`), que ClientePanel parsea.
          responseUrl: `${window.location.origin}/pagos/payphone/respuesta`,
          email: d.email || undefined,
          lang: 'es',
        };
        if (d.payphone_store_id) config.storeId = d.payphone_store_id;

        // La Cajita escribe en su propio nodo, creado a mano: React solo conoce al `huesped`, así que
        // nada de lo que haga Payphone con el DOM puede descuadrar el árbol de React.
        const caja = document.createElement('div');
        caja.id = contenedorId;
        contenedor.appendChild(caja);
        // eslint-disable-next-line no-undef
        new window.PPaymentButtonBox(config).render(contenedorId);
      })
      .catch((err) => setError(mensajeErrorApi(err, 'No se pudo cargar el pago con tarjeta. Usa transferencia bancaria por ahora.')))
      .finally(() => { if (!cancelado) setCargando(false); });

    return () => {
      cancelado = true;
      try { if (contenedor) contenedor.textContent = ''; } catch (e) { /* ya no está */ }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return <p className="text-sm text-secondary" style={{ marginTop: 'var(--spacing-2)' }}>{error}</p>;
  }

  return (
    <div style={{ marginTop: 'var(--spacing-3)', minWidth: 0 }}>
      {montos && (
        <div style={{ border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)', padding: 'var(--spacing-3)', marginBottom: 'var(--spacing-3)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0' }}>
            <span className="text-sm">Saldo de tu liquidación</span>
            <span className="text-sm">${montos.saldo}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0' }}>
            <span className="text-sm">Comisión de Payphone</span>
            <span className="text-sm">${montos.recargo}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0 0', borderTop: '1px solid var(--color-border)', marginTop: '4px', fontWeight: 700 }}>
            <span className="text-sm">Total a cobrar a tu tarjeta</span>
            <span>${montos.total}</span>
          </div>
          <p className="text-xs text-secondary" style={{ margin: '6px 0 0' }}>
            La comisión es el {montos.recargo_pct}% de lo que se cobra a la tarjeta. Si prefieres no pagarla, puedes pagar por transferencia bancaria.
          </p>
        </div>
      )}
      {cargando && <p className="text-sm text-secondary">Cargando pago con tarjeta...</p>}
      {/* overflowX + minWidth:0 — la Cajita puede pedir más ancho del que tiene la tarjeta; que se
          desplace ella sola en vez de forzar el ancho de toda la página. */}
      <div ref={huesped} translate="no" style={{ overflowX: 'auto', minWidth: 0 }} />
    </div>
  );
}
